import { Record } from 'immutable';

const {
    HOROSCOPE_LIST_REQUEST,
    HOROSCOPE_LIST_SUCCESS,
    HOROSCOPE_LIST_FAILURE,

    FIND_USER_HOROSCOPE_REQUEST,
    FIND_USER_HOROSCOPE_SUCCESS,
    FIND_USER_HOROSCOPE_FAILURE,

    USER_ACTIVE_HOROSCOPES_REQUEST,
    USER_ACTIVE_HOROSCOPES_SUCCESS,
    USER_ACTIVE_HOROSCOPES_FAILURE,

    SELECT_SINGLE_HOROSCOPE_REQUEST,

    SELECT_SINGLE_LIFE_EVENT_REQUEST,

    SELECT_HOROSCOPE_PLAN_REQUEST,

    CHECK_IF_LIVE_REQUEST,
    CHECK_IF_LIVE_SUCCESS,
    CHECK_IF_LIVE_FAILURE,

    USER_PREVIOUS_HOROSCOPES_REQUEST,
    USER_PREVIOUS_HOROSCOPES_SUCCESS,
    USER_PREVIOUS_HOROSCOPES_FAILURE,

    GET_NEW_SINGLE_HOROSCOPE_REQUEST,
    GET_NEW_SINGLE_HOROSCOPE_SUCCESS,
    GET_NEW_SINGLE_HOROSCOPE_FAILURE,

    SELECT_SELECTED_HOROSCOPE,

    MOONSIGN_LOOKUP_REQUEST,
    MOONSIGN_LOOKUP_SUCCESS,
    MOONSIGN_LOOKUP_FAILURE,

    RISING_SIGN_LOOKUP_REQUEST,
    RISING_SIGN_LOOKUP_SUCCESS,
    RISING_SIGN_LOOKUP_FAILURE,

    RESET_MOONSIGN_LOOKUP,
    RESET_RISING_SIGN_LOOKUP,

    GET_YEARLY_LIFE_EVENT_REQUEST,
    GET_YEARLY_LIFE_EVENT_SUCCESS,
    GET_YEARLY_LIFE_EVENT_FAILURE,
    RESET_YEARLY_LIFE_EVENT,

    PURCHASE_YEARLY_HOROSCOPE_REQUEST,
    PURCHASE_YEARLY_HOROSCOPE_SUCCESS,
    PURCHASE_YEARLY_HOROSCOPE_FAILURE,
    RESET_YEARLY_HOROSCOPE_PURCHASE,

    GET_SPECIAL_FORECAST_REQUEST,
    GET_SPECIAL_FORECAST_SUCCESS,
    GET_SPECIAL_FORECAST_FAILURE,
    RESET_SPECIAL_FORECAST,
} = require('./horoscopeActions').constants;

const {
    LOGOUT_SUCCESS,
} = require('../user/userActions').constants;

const InitialState = Record({
    isFetching: false,
    isFetchingPrevious: false,
    hasFetchedHorosopes: false,
    error: null,
    horoscopes: [],
    singleHoroscope: {},
    singleHoroscopesList: [],
    singleLifeEvent: {},
    userActiveHoroscopes: {},
    singleHoroscopeGenerated: {},
    horoscopePlan: {},
    isLiveChecking: false,
    horocopeStreamingLiveData: false,
    noUserHoroscope: {},
    selectedHoroscope: {},
    searchedMoonsign: {},
    searchedRisingSign: {},
    yearlyLifeEvent: null,
    isFetchingLifeEvent: false,
    lifeEventError: null,
    // Yearly horoscope purchase
    yearlyPurchase: null,
    isPurchasingYearly: false,
    yearlyPurchaseError: null,
    // Special forecast
    specialForecast: null,
    isFetchingSpecialForecast: false,
    specialForecastError: null,
});

const initialState = new InitialState();

export default function horoscopeReducer(state = initialState, { payload, type }) {
    if (!(state instanceof InitialState)) return initialState.merge(state);

    switch (type) {

    case LOGOUT_SUCCESS:
        return state.set('isFetching', false)
            .set('horoscopes', [])
            .set('singleHoroscope', {})
            .set('singleHoroscopeGenerated', {})
            .set('userActiveHoroscopes', {})
            .set('singleLifeEvent', {})
            .set('singleHoroscopesList', [])
            .set('horoscopePlan', {})
            .set('isLiveChecking', false)
            .set('horocopeStreamingLiveData', false)
            .set('noUserHoroscope', {})
            .set('error', null);

    case HOROSCOPE_LIST_REQUEST:
    case FIND_USER_HOROSCOPE_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case HOROSCOPE_LIST_SUCCESS:
        return state.set('isFetching', false)
            .set('horoscopes', payload.data);

    case CHECK_IF_LIVE_REQUEST:
        return state.set('isLiveChecking', true)
            .set('error', null);

    case CHECK_IF_LIVE_SUCCESS:
        return state.set('isLiveChecking', false)
            .set('horocopeStreamingLiveData', payload.data);

    case CHECK_IF_LIVE_FAILURE:
        return state.set('isLiveChecking', false)
            .set('error', payload.data);

    case FIND_USER_HOROSCOPE_SUCCESS:
        return state.set('isFetching', false)
            .set('singleHoroscope', payload.data.horoscope)
            .set('singleHoroscopeGenerated', payload.data.horoscope);

    case USER_ACTIVE_HOROSCOPES_REQUEST:
        return state.set('isFetching', true)
            .set('hasFetchedHorosopes', false)
            .set('error', null);

    case USER_ACTIVE_HOROSCOPES_SUCCESS:
        return state.set('isFetching', false)
            .set('userActiveHoroscopes', payload)
            .set('hasFetchedHorosopes', true);

    case USER_ACTIVE_HOROSCOPES_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    case HOROSCOPE_LIST_FAILURE:
    case FIND_USER_HOROSCOPE_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    case SELECT_SINGLE_HOROSCOPE_REQUEST:
        return state.set('singleHoroscope', payload);

    case SELECT_SINGLE_LIFE_EVENT_REQUEST:
        return state.set('singleLifeEvent', payload);

    case SELECT_HOROSCOPE_PLAN_REQUEST:
        return state.set('horoscopePlan', payload);

    case GET_NEW_SINGLE_HOROSCOPE_REQUEST:
        return state.set('isFetching', true)
            .set('error', null);

    case GET_NEW_SINGLE_HOROSCOPE_SUCCESS:
    {
        // Reverse horoscopeData so carousel shows oldest-to-newest (API returns date DESC)
        const horoscopeData = [...(payload.data.horoscope.horoscopeData || [])].reverse();
        return state.set('isFetching', false)
            .set('singleHoroscope', { ...payload.data.horoscope, horoscopeData });
    }

    case GET_NEW_SINGLE_HOROSCOPE_FAILURE:
        return state.set('isFetching', false)
            .set('error', payload);

    case USER_PREVIOUS_HOROSCOPES_REQUEST: {
        return state.set('isFetchingPrevious', true)
            .set('error', null);
    }

    case USER_PREVIOUS_HOROSCOPES_SUCCESS: {
        return state.set('isFetchingPrevious', false)
            .set('userActiveHoroscopes', payload)
            .set('hasFetchedHorosopes', false);
    }

    case USER_PREVIOUS_HOROSCOPES_FAILURE: {
        return state.set('isFetchingPrevious', false)
            .set('error', payload.data);
    }

    case SELECT_SELECTED_HOROSCOPE: {
        return state.set('selectedHoroscope', payload);
    }

    case MOONSIGN_LOOKUP_REQUEST: {
        return state.set('isFetching', true)
            .set('error', null);
    }

    case MOONSIGN_LOOKUP_SUCCESS: {
        return state.set('isFetching', false)
            .set('searchedMoonsign', payload);
    }

    case MOONSIGN_LOOKUP_FAILURE: {
        return state.set('isFetching', false)
            .set('error', payload);
    }

    case RESET_MOONSIGN_LOOKUP: {
        return state.set('searchedMoonsign', {});
    }

    case RISING_SIGN_LOOKUP_REQUEST: {
        return state.set('isFetching', true)
            .set('error', null);
    }

    case RISING_SIGN_LOOKUP_SUCCESS: {
        return state.set('isFetching', false)
            .set('searchedRisingSign', payload);
    }

    case RISING_SIGN_LOOKUP_FAILURE: {
        return state.set('isFetching', false)
            .set('error', payload);
    }

    case RESET_RISING_SIGN_LOOKUP: {
        return state.set('searchedRisingSign', {});
    }

    case GET_YEARLY_LIFE_EVENT_REQUEST: {
        return state.set('isFetchingLifeEvent', true)
            .set('lifeEventError', null);
    }

    case GET_YEARLY_LIFE_EVENT_SUCCESS: {
        return state.set('isFetchingLifeEvent', false)
            .set('yearlyLifeEvent', payload)
            .set('lifeEventError', null);
    }

    case GET_YEARLY_LIFE_EVENT_FAILURE: {
        return state.set('isFetchingLifeEvent', false)
            .set('lifeEventError', payload);
    }

    case RESET_YEARLY_LIFE_EVENT: {
        return state.set('yearlyLifeEvent', null)
            .set('lifeEventError', null);
    }

    case PURCHASE_YEARLY_HOROSCOPE_REQUEST: {
        return state.set('isPurchasingYearly', true)
            .set('yearlyPurchaseError', null)
            .set('yearlyPurchase', null);
    }

    case PURCHASE_YEARLY_HOROSCOPE_SUCCESS: {
        return state.set('isPurchasingYearly', false)
            .set('yearlyPurchase', payload)
            .set('yearlyPurchaseError', null);
    }

    case PURCHASE_YEARLY_HOROSCOPE_FAILURE: {
        return state.set('isPurchasingYearly', false)
            .set('yearlyPurchaseError', payload);
    }

    case RESET_YEARLY_HOROSCOPE_PURCHASE: {
        return state.set('yearlyPurchase', null)
            .set('isPurchasingYearly', false)
            .set('yearlyPurchaseError', null);
    }

    case GET_SPECIAL_FORECAST_REQUEST: {
        return state.set('isFetchingSpecialForecast', true)
            .set('specialForecastError', null);
    }

    case GET_SPECIAL_FORECAST_SUCCESS: {
        return state.set('isFetchingSpecialForecast', false)
            .set('specialForecast', payload)
            .set('specialForecastError', null);
    }

    case GET_SPECIAL_FORECAST_FAILURE: {
        return state.set('isFetchingSpecialForecast', false)
            .set('specialForecastError', payload);
    }

    case RESET_SPECIAL_FORECAST: {
        return state.set('specialForecast', null)
            .set('specialForecastError', null);
    }

    default:
        return state;
    }
}
